module.exports = __webpack_public_path__ + "static/android-chrome-192x192-88ddfc0c0397fbe47f56d4302516155a.png";